import { twMerge } from 'tailwind-merge'
import { Tooltip } from '@highlight/ui'
import { confidenceLevel, type ConfidenceLevel } from '../hooks/staged-actions/confidence'
import type { StagedAction } from '../hooks/staged-actions/types'

const FILLED_BARS: Record<ConfidenceLevel, number> = { low: 1, mid: 2, high: 3 }
const BAR_HEIGHTS = ['h-1.5', 'h-2.5', 'h-3.5']

/** How sure the planner was, as one to three rising bars in the current text colour. */
export function ConfidenceBar({ action, className }: { action: StagedAction; className?: string }) {
  const level = confidenceLevel(action)
  if (!level) return null
  const filled = FILLED_BARS[level]
  return (
    <Tooltip>
      <Tooltip.Trigger
        render={
          <span
            role="img"
            aria-label={`${level} confidence`}
            data-confidence-level={level}
            className={twMerge('flex h-6 shrink-0 items-end gap-0.5 px-1 pb-[5px]', className)}
          >
            {BAR_HEIGHTS.map((height, index) => (
              <span
                key={height}
                className={twMerge('w-[3px] rounded-full bg-current', height, index >= filled && 'opacity-25')}
              />
            ))}
          </span>
        }
      />
      <Tooltip.Content side="left" sideOffset={6}>
        {`${level[0].toUpperCase()}${level.slice(1)} confidence action`}
      </Tooltip.Content>
    </Tooltip>
  )
}
